module.exports = __webpack_public_path__ + "static/media/l.12ff9da1.gif";